import { render, staticRenderFns } from "./WeeklyData.vue?vue&type=template&id=1a0edbf4&lang=pug"
import script from "./WeeklyData.vue?vue&type=script&lang=js"
export * from "./WeeklyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports